export { default } from './Renegociacao25Confira';
